<script>
    import { replace } from 'svelte-spa-router';
import { recetaActiva } from '../controlador/store';

    export let plantilla;
    function eliminar(){
        //cambiar valor en activo
    }
    function editar(){
        
        replace('/nueva/plantilla');
    }
    function usarPlantilla(){
        $recetaActiva = {documento:"",nombre:"",mutual:"",afiliado:"",cuerpo:plantilla.cuerpo};
        replace('/nueva/receta');
    }
</script>
<div class="carta">
    <div class="titulo">
        {plantilla.nombre}
    </div>
    <div class="botonera">
        <button class="boton" on:click={usarPlantilla}><i class="ph-hand-pointing"></i></button>
    </div>
</div>

<style>
    .carta{
        width: 90%;
        max-width: 380px;
        height: 60px;
        background: linear-gradient(135deg, rgba(255,255,255,1) 0%, rgba(207,215,255,1) 100%);
        color: var(--negro);
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        border-radius: 20px;
    }
    .titulo{
        width: calc(100% - 100px);
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-left: 10px;
        font-size: 12px;
    }
    .botonera{
        width: 100px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .boton{
        background: transparent;
        width: 40px;
        height: 40px;
        color: var(--azul);
        margin: auto;
        border: none;
        outline: none;
        cursor: pointer;
        font-size: 40px;
        font-weight: bold;
    }
</style>